import PaymentMethodResource from "./paymentMethod.resource";

const paymentMethodModule = angular
  .module("app.resources.paymentMethod", [])
  .service("PaymentMethod", PaymentMethodResource);

export default paymentMethodModule;



// WEBPACK FOOTER //
// ./src/resources/paymentMethod/paymentMethod.module.js